
// import { useState, useEffect, useMemo } from "react";
// import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
// import { ThemeProvider } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
// import rtlPlugin from "stylis-plugin-rtl";
// import { CacheProvider } from "@emotion/react";
// import createCache from "@emotion/cache";

// import Sidenav from "examples/Sidenav";
// import theme from "assets/theme";
// import themeRTL from "assets/theme/theme-rtl";
// import themeDark from "assets/theme-dark";
// import themeDarkRTL from "assets/theme-dark/theme-rtl";
// import { useMaterialUIController, setMiniSidenav } from "context";
// import routes from "routes";
// import brandWhite from "assets/images/small-logos/logo-ct.png";
// import brandDark from "assets/images/logo-ct-dark.png";
// import Basic from "layouts/authentication/sign-in";
// import AutoLogout from "autologout";

// export default function App() {
//   const [controller, dispatch] = useMaterialUIController();
//   const {
//     miniSidenav,
//     direction,
//     layout,
//     sidenavColor,
//     transparentSidenav,
//     whiteSidenav,
//     darkMode,
//   } = controller;

//   const [onMouseEnter, setOnMouseEnter] = useState(false);
//   const [rtlCache, setRtlCache] = useState(null);
//   const { pathname } = useLocation();
//   const navigate = useNavigate();
//   const isLoggedIn = localStorage.getItem("sessionToken"); // Check if the user is logged in

//   // RTL Cache
//   useMemo(() => {
//     const cacheRtl = createCache({
//       key: "rtl",
//       stylisPlugins: [rtlPlugin],
//     });
//     setRtlCache(cacheRtl);
//   }, []);

//   // Handle sidenav hover behavior
//   const handleOnMouseEnter = () => {
//     if (miniSidenav && !onMouseEnter) {
//       setMiniSidenav(dispatch, false);
//       setOnMouseEnter(true);
//     }
//   };

//   const handleOnMouseLeave = () => {
//     if (onMouseEnter) {
//       setMiniSidenav(dispatch, true);
//       setOnMouseEnter(false);
//     }
//   };

//   // Set direction attribute
//   useEffect(() => {
//     document.body.setAttribute("dir", direction);
//   }, [direction]);

//   // Scroll to top on route change
//   useEffect(() => {
//     document.documentElement.scrollTop = 0;
//     document.scrollingElement.scrollTop = 0;
//   }, [pathname]);

//   // Redirect logic
//   useEffect(() => {
//     if (!isLoggedIn && pathname !== "/") {
//       // Redirect to sign-in page if not logged in
//       navigate("/", { state: { from: pathname } });
//     } else if (isLoggedIn && pathname === "/") {
//       // Redirect to the intended page after login
//       const from = location.state?.from || "/Tables";
//       navigate(from, { replace: true });
//     }
//   }, [isLoggedIn, pathname, navigate]);

//   const getRoutes = (allRoutes) =>
//     allRoutes.map((route) => {
//       if (route.collapse) {
//         return getRoutes(route.collapse);
//       }
//       if (route.route) {
//         return <Route exact path={route.route} element={route.component} key={route.key} />;
//       }
//       return null;
//     });

//   const configsButton = <></>;

//   return direction === "rtl" ? (
//     <CacheProvider value={rtlCache}>
//       <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
//         <CssBaseline />
//         <AutoLogout timeout={15 * 60 * 1000} /> {/* Auto logout after 15 minutes */}
//         {layout === "dashboard" && <>{configsButton}</>}
//         <Routes>
//           {getRoutes(routes)}
//           <Route path="/" element={isLoggedIn ? <Navigate to="/Tables" /> : <Basic />} />
         
//           <Route
//             path="*"
//             element={
//               isLoggedIn ? (
//                 <Navigate to={pathname} />
//               ) : (
//                 <Navigate to="/" state={{ from: pathname }} />
//               )
//             }
//           />
//         </Routes>
//       </ThemeProvider>
//     </CacheProvider>
//   ) : (
//     <ThemeProvider theme={darkMode ? themeDark : theme}>
//       <CssBaseline />
//       <AutoLogout timeout={15 * 60 * 1000} />
//       {layout === "dashboard" && (
//         <>
//           <Sidenav
//             color={sidenavColor}
//             brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
//             brandName="Examplad"
//             routes={routes}
//             onMouseEnter={handleOnMouseEnter}
//             onMouseLeave={handleOnMouseLeave}
//           />
//           {configsButton}
//         </>
//       )}
//       <Routes>
//         {getRoutes(routes)}
//         <Route path="/" element={isLoggedIn ? <Navigate to="/Tables" /> : <Basic />} />
//         <Route
//           path="*"
//           element={
//             isLoggedIn ? (
//               <Navigate to={pathname} />
//             ) : (
//               <Navigate to="/" state={{ from: pathname }} />
//             )
//           }
//         />
//       </Routes>
//     </ThemeProvider>
//   );
// }

import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import Sidenav from "examples/Sidenav";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import { useMaterialUIController, setMiniSidenav } from "context";
import routes from "routes";
import brandWhite from "assets/images/small-logos/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import AutoLogout from "autologout";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;

  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isLoggedIn = !!localStorage.getItem("sessionToken");

  // ✅ PUBLIC ROUTES (VERY IMPORTANT)
  const publicRoutes = [
    "/authentication/sign-in",
    "/authentication/sign-up-list",
  ];

  // RTL cache
  useMemo(() => {
    const cache = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cache);
  }, []);

  // Mini sidenav hover
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Direction
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Scroll to top
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // 🔐 AUTH GUARD (FIXED)
  useEffect(() => {
    // Not logged in & trying private route
    if (!isLoggedIn && !publicRoutes.includes(pathname)) {
      navigate("/authentication/sign-in", {
        replace: true,
        state: { from: pathname },
      });
    }

    // Logged in & trying auth pages
    if (isLoggedIn && publicRoutes.includes(pathname)) {
      navigate("/Tables", { replace: true });
    }
  }, [isLoggedIn, pathname, navigate]);

  // Route mapper
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        const childRoutes = getRoutes(route.collapse);
        if (route.route) {
          return [
            <Route key={route.key} path={route.route} element={route.component} />,
            ...childRoutes,
          ];
        }
        return childRoutes;
      }
      if (route.route) {
        return (
          <Route
            key={route.key}
            path={route.route}
            element={route.component}
          />
        );
      }
      return null;
    });

  const configsButton = <></>;

  const appContent = (
    <>
      <CssBaseline />
      <AutoLogout timeout={15 * 60 * 1000} />

      {layout === "dashboard" && isLoggedIn && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandWhite : brandWhite}
            brandName="Examplad"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          {configsButton}
        </>
      )}

      <Routes>
        {getRoutes(routes)}

        {/* Root */}
        <Route
          path="/"
          element={<Navigate to="/authentication/sign-in" replace />}
        />

        {/* Fallback */}
        <Route
          path="*"
          element={
            isLoggedIn ? (
              <Navigate to="/Tables" replace />
            ) : (
              <Navigate to="/authentication/sign-in" replace />
            )
          }
        />
      </Routes>
    </>
  );

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        {appContent}
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      {appContent}
    </ThemeProvider>
  );
}